import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { ArrowRight } from "lucide-react";

const SimplePageLayout = ({ children }) => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white">
      {/* Simple Header */}
      <header className="bg-white/80 backdrop-blur-lg border-b border-orange-100 sticky top-0 z-50">
        <div className="calli-container py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="text-2xl font-black gradient-text">calli</a>
            <button 
              onClick={() => navigate('/')}
              className="text-gray-600 hover:text-orange-500 transition-colors flex items-center gap-2"
            >
              <ArrowRight className="w-4 h-4 rotate-180" />
              {language === 'fr' ? 'Retour' : 'Back'}
            </button>
          </div>
        </div>
      </header>
      
      {/* Content */}
      <main className="calli-container py-16">
        {children}
      </main>
      
      {/* Simple Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="calli-container text-center">
          <p className="text-gray-400">© 2026 Calli. {language === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}</p>
        </div>
      </footer>
    </div>
  );
};

export default SimplePageLayout;
